const APIURL = 'https://vber-api.whale4cloud.com';
const CDNURL = 'https://vber-api.whale4cloud.com';
export {
  APIURL, CDNURL
};



// WEBPACK FOOTER //
// ./src/config/urlconfig.js